import Marquee from "react-fast-marquee";

const items = [
  "FLUTTER · DART",
  "CLEAN ARCHITECTURE",
  "BLOC · CUBIT",
  "RIVERPOD",
  "NATIVE INTEGRATIONS",
  "DEVTOOLS · PERFORMANCE PROFILING",
  "PROVIDER",
  "GET_IT · INJECTABLE",
  "GO_ROUTER · DEEP LINKING",
  "FIREBASE · CLOUD FUNCTIONS",
  "REST API · DIO",
  "FREEZED · JSON_SERIALIZABLE",
  "DRIFT · SQLITE",
  "REVENUECAT",
  "UNIT · WIDGET · INTEGRATION TESTS",
  "SENTRY",
  "CI/CD · FASTLANE · APP RELEASES",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-white/5 bg-surface/40 py-5" data-testid="editorial-marquee">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {items.map((t) => (
          <span key={t} className="mx-8 flex items-center gap-8 font-mono text-xs tracking-[0.35em] text-zinc-500">
            {t}
            <span className="text-accent">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
